export default {
    props:['value', 'error'],
    data: function() {
        return {
            isFocused: this.value,
            isBlur: false
        }
    }
};
